import { Card, Empty } from 'antd';
export default function TestingPage() {
  return <Card style={{marginTop:16}} title="测试管理"><Empty description="请在AI全流程中完成测试" /></Card>;
}
